import { createAction, props } from '@ngrx/store';

import { MilkDeliveryMonthSummary, MilkDeliverySummary } from '../../models/milk-delivery.model';

export const loadMilkDeliveriesRequest = createAction(
  '[MilkDelivery] Load milk deliveries request',
  props<{ start: string; end: string }>(),
);

export const loadMilkDeliveriesSuccess = createAction(
  '[MilkDelivery] Load production attention limits by date',
  props<{ milkDeliverySummary: MilkDeliverySummary[] }>(),
);

export const loadMilkDeliveriesMonthSummaryRequest = createAction(
  '[MilkDelivery] Load milk deliveries summary per month request',
  props<{ start: string; end: string }>(),
);

export const loadMilkDeliveriesMonthSummarySuccess = createAction(
  '[MilkDelivery] Load milk deliveries summary per month success',
  props<{ milkDeliveryMonthSummary: MilkDeliveryMonthSummary }>(),
);
